import { Box } from "@mui/material";
import OrganizationClientBrain from "components/Admin/Organizations/OrganizationDetail/OrganizationClientBrain/OrganizationClientBrain";
import { observer } from "mobx-react";
import React from "react";
import { Navigate } from "react-router-dom";
import { AuthStore } from "stores/AuthStore";
import { useStore } from "utils/useStore";

const KboClientBrain = observer(() => {
    const authStore = useStore(AuthStore);

    if (!authStore.canUserView("Client Brain")) {
        return <Navigate to="/app/kbo/chats" replace />;
    }

    return (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
            <OrganizationClientBrain
                canEdit={authStore.canUserEdit("Client Brain")}
                hideBreadcrumbs
                contentPadding={3}
                fullWidth
            />
        </Box>
    );
});

export default KboClientBrain;
